import { PhoneNumberField } from '@gasbi/shared/common/components/FormFields';
import { FormSection } from '@gasbi/shared/web/components/FormSection';

import { CreateSubdivisionStepProps } from '../types';

const ContactInfoStep = ({ formik }: CreateSubdivisionStepProps) => (
  <FormSection title='Контактна інформація'>
    <PhoneNumberField control={formik} name='details.phoneNumber' required />
  </FormSection>
);

export default ContactInfoStep;
